import { Button, Card, CardBody, Divider } from '@heroui/react';
import { Icon } from '@iconify/react';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EduModal } from '@/components/education/EduModal';
import useAppEvents from '@/patient-app-common/hooks/useAppEvents';
import { AppEvent } from '@/patient-app-common/types/ApplicationEvent';

export function FutureList() {
  const { t } = useTranslation('todo');
  const { futureTodos } = useAppEvents();
  const [count, setCount] = useState(5);

  if (!futureTodos.length) return null;

  return (
    <div className="my-8 space-y-4">
      <h2 className="font-light text-2xl">{t('futurelist.title')}</h2>
      <Card shadow="sm" className="p-0">
        <CardBody className="px-8 py-0">
          <ol className="relative border-s-1 border-dotted border-secondary-500">
            {_.take(futureTodos, count).map((event) => (
              <FutureEvent key={event.id} event={event} />
            ))}
          </ol>
        </CardBody>
      </Card>
      {count < futureTodos.length && (
        <Button
          className="flex place-self-center"
          color="primary"
          endContent={<Icon className="text-lg" icon="mdi:chevron-down" />}
          onPress={() => setCount(count + 5)}
          variant="faded"
        >
          {t('common.action.show_more')}
        </Button>
      )}
    </div>
  );
}

interface FutureEventProps {
  event: AppEvent;
}

function FutureEvent({ event }: FutureEventProps) {
  const { t } = useTranslation('todo');
  const [eduModal, toggleEduModal] = useState(false);

  return (
    <>
      <EduModal
        event={event}
        source="FutureEvent"
        onClose={() => toggleEduModal(false)}
        isOpen={eduModal}
      />
      <li className="my-8 ms-4">
        <div className="absolute w-4 h-4 bg-secondary-500 rounded-full mt-1.5 -start-2 border-2 border-primary-100"></div>
        <time className="font-light text-sm mb-1">
          {dayjs(event.startDateTime).format('LL')}
        </time>
        <h3 className="font-semibold">{event.title}</h3>
        <p className="font-light">{event.subtitle}</p>
        {!_.isEmpty(event.edIds) && (
          <div className="flex flex-col items-end mt-2">
            <Button
              color="primary"
              onPress={() => toggleEduModal(true)}
              variant="flat"
            >
              {event.options.linkText || t('common.link.learn_more')}
            </Button>
          </div>
        )}
      </li>
      <Divider className="ml-4" />
    </>
  );
}
